import { MODAL_MAIN_CONTENT_HEIGHT_WITH_CTA } from 'src/pages/consumer/components/DishFirstHeader';
import { CloseSmall } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${Spacing.SINGLE} ${Spacing.TRIPLE};
  margin: auto;
  max-width: 1500px;
  padding: ${Spacing.SINGLE} ${Spacing.SINGLE_HALF};

  ${Mixins.Media.maxWidthMedium(`
    grid-template-columns: 1fr 1fr;
  `)}

  ${Mixins.Media.maxWidthSmall(`
    display: flex;
    flex-direction: column;
    overflow: scroll;
    gap: 0;
    height: ${MODAL_MAIN_CONTENT_HEIGHT_WITH_CTA};
    padding: 0;
  `)}
`;

export const ClearButton = styled(Clickable)<{ show?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  order: 10;
  margin-right: ${Spacing.SINGLE};
  transform: translateY(${ifProp('show', '0', Spacing.DOUBLE)});
  transition: transform ${Transition.Time.BASE};
`;

export const ClearIcon = CloseSmall;
